import { useSetSelectedPerson, useSetSelectedRoomState } from "@/shared/client";
import type { RoomSelectionProps } from "../types";

export const useRoomSelection = () => {
    const setSelectedRooms = useSetSelectedRoomState();
    const setSelectedPerson = useSetSelectedPerson();

    const handleRoomSelection = ({ roomIdx, isSelected, newOffPrice, person }: RoomSelectionProps) => {
        setSelectedPerson({ adult: 0, child: 0, infant: 0 });
        setSelectedRooms((prev) => {
            if (isSelected) {
                const updatedRooms = prev.filter((room) => room.roomIdx !== roomIdx);
                return [...updatedRooms, { roomIdx, newOffPrice, person }];
            }

            if (!isSelected) {
                return prev.filter((room) => room.roomIdx !== roomIdx);
            }

            return [];
        });
    };

    return { handleRoomSelection };
};
